import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})

export class HostnameUtilService {
  public getProtocolAndHostname() {
    const hostname = window.location.host;
    if (hostname.includes('localhost')) {
      return 'https://akaun.dev';
    } else {
      return 'https://' + window.location.host;
    }
  }
}
